/**
  * Represents the different case permission types in the Case Manager application.
  * Used through the application to identify what users have access to.
 */
export enum InvestigationPermission {
  // =====================================================
  // CASE MANAGEMENT PERMISSIONS - cm.*
  // =====================================================

  /** View cases assigned to any team member */
  CaseManagementViewOpen = 'cm.view_open',

  /** Create new cases in the system */
  CaseManagementCreate = 'cm.create',

  /** Modify cases assigned to any team member */
  CaseManagementEditOpen = 'cm.edit_open',

  /** Approve case resolutions and closures */
  CaseManagementApprove = 'cm.approve',

  /** Transfer cases to other team members */
  CaseManagementReassign = 'cm.reassign',

  /** Gateway permission to access Admin Settings */
  CaseManagementAccessSettings = 'cm.access_settings',

  /** Convert HR cases to formal ER investigations */
  CaseManagementConvert = 'cm.convert',

  /** Restore closed cases to active status */
  CaseManagementReopen = 'cm.reopen',

  /** Access activity logs and audit history */
  CaseManagementViewAuditLog = 'cm.view_audit_log',

  /** Generate and download the legal packet PDF for an investigation */
  CaseManagementExportLegalPacket = 'cm.export_legal_packet',

  /** Access the intake queue to review and assign incoming investigations */
  CaseManagementViewIntakeQueue = 'cm.view_intake_queue',

  // =====================================================
  // ATTACHMENTS PERMISSIONS (4) - attach.*
  // =====================================================

  /** View case attachments and files */
  AttachmentsView = 'attach.view',

  /** Upload attachments to cases */
  AttachmentsUpload = 'attach.upload',

  /** Download case attachments and files */
  AttachmentsDownload = 'attach.download',

  /** Remove attachments from cases */
  AttachmentsDelete = 'attach.delete',

  // =====================================================
  // SENSITIVE FIELDS ACCESS PERMISSIONS (5) - sf.*
  // =====================================================

  /** See protected case fields and data */
  SensitiveFieldsViewSensitive = 'sf.view_sensitive',

  /** Access personally identifiable information */
  SensitiveFieldsViewPii = 'sf.view_pii',

  /** See salary, bonus, and equity data */
  SensitiveFieldsViewCompensation = 'sf.view_compensation',

  /** Access HIPAA-protected health information */
  SensitiveFieldsViewMedical = 'sf.view_medical',

  /** See legal holds and litigation data */
  SensitiveFieldsViewLegal = 'sf.view_legal',

  // =====================================================
  // ANALYTICS PERMISSIONS (2) - analytics.*
  // =====================================================

  /** Access reports, dashboards, and insights */
  AnalyticsView = 'analytics.view',

  /** Download reports in various formats */
  AnalyticsExport = 'analytics.export'
}
